export default "__VITE_ASSET__DOTp9syE__"